(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/carousel-widescreen/views/carousel-widescreen.js') >= 0) return;  svs.modules.push('/components/banner_layouts/carousel-widescreen/views/carousel-widescreen.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.banner_layouts=_svs.banner_layouts||{};
_svs.banner_layouts.carousel_widescreen=_svs.banner_layouts.carousel_widescreen||{};
_svs.banner_layouts.carousel_widescreen.templates=_svs.banner_layouts.carousel_widescreen.templates||{};
svs.banner_layouts.carousel_widescreen.templates.carousel_widescreen = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"components-tb_ui-carousel-carousel_slide"),depth0,{"name":"components-tb_ui-carousel-carousel_slide","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
Handlebars.partials['components-banner_layouts-carousel_widescreen-carousel_widescreen'] = svs.banner_layouts.carousel_widescreen.templates.carousel_widescreen;
})(svs, Handlebars);


 })(window);